export enum UserRole {
  Admin = 'Admin',
  BugoAgencyAdmin = 'BugoAgencyAdmin',
  BugoAgencyBranchAdmin = 'BugoAgencyBranchAdmin',
  BugoFuneralHome = 'BugoFuneralHome',
  BugoAgencyWorker = 'BugoAgencyWorker',
  BugoCustomer = 'BugoCustomer',
  BugoGuest = 'BugoGuest',
  StoreSeller = 'StoreSeller',
  StoreSellerAdmin = 'StoreSellerAdmin',
  StoreSellerWorker = 'StoreSellerWorker',
  StoreCustomer = 'StoreCustomer',
  StoreGuest = 'StoreGuest',
  GiftAgent = 'GiftAgent',
  //* GiftAgent에 더해 주는 금액 담당자 권한 (roles: [GiftAgent, GiftAgentAdmin]). 스펙: docs/gift-agent-admin-spec.md
  GiftAgentAdmin = 'GiftAgentAdmin',
  GiftBrandSeller = 'GiftBrandSeller',
}

export enum DeliveryState {
  BEFORE_PREPARING = 'BeforePreparing',
  PREPARING = 'Preparing',
  DELIVERYING = 'Deliverying',
  DELIVERED = 'Delivered',
}

export enum PaymentState {
  NOT_PAID = 'NotPaid',
  WAITING = 'Waiting',
  PAID = 'Paid',
  CANCEL_REQUESTED = 'CancelRequested',
  CANCELED = 'Canceled',
  CONFIRMED = 'Confirmed',
}

export enum Gender {
  Male = '남',
  Femail = '여',
}

export type CustomCallback<A, T> = (e: A) => Promise<T> | T;

export type FeventDate = {
  date: Date | null;
  timeDefined: boolean;
};

export enum LowerRole {
  Admin = 'admin',
  NonAdmin = 'non-admin',
  BugoAgencyAdmin = 'bugo-agency-admin',
  BugoAgencyBranchAdmin = 'bugo-agency-branch-admin',
  BugoFuneralHome = 'bugo-funeralHome',
  BugoAgencyWorker = 'bugo-agency-worker',
  BugoCustomer = 'bugo-customer',
  BugoGuest = 'bugo-guest',
  StoreSeller = 'store-seller',
  StoreCustomer = 'store-customer',
  StoreGuest = 'store-guest',
  GiftBrandSeller = 'gift-brand-seller',
  GiftAgent = 'gift-agent',
  GiftAgentAdmin = 'gift-agent-admin',
  Public = 'public',
}

//* 답례품 정산 쓰기 prefix — Admin은 전체, GiftAgentAdmin은 마리 범위(범위 밖 403)
export type GiftSettlementWriteRole = LowerRole.Admin | LowerRole.GiftAgentAdmin;

export enum CamelRole {
  Admin = 'admin',
  BugoAgencyAdmin = 'bugoAgencyAdmin',
  BugoFuneralHome = 'bugoFuneralHome',
  BugoAgencyWorker = 'bugoAgencyWorker',
  BugoCustomer = 'bugoCustomer',
  BugoGuest = 'bugoGuest',
  StoreSeller = 'storeSeller',
  StoreCustomer = 'storeCustomer',
  StoreGuest = 'storeGuest',
  Public = 'public',
}

export enum UserCustomTheme {
  Default = 'Default',
  Preed = 'Preed',
  Dark = 'Dark',
  DaeMyung = 'DaeMyung',
}

export enum AlertMethod {
  MESSAGE = 'Message',
  KAKAO = 'Kakao',
}

export enum UpsertMode {
  Update = 'Update',
  Insert = 'Insert',
}
